<common-top-tool-bar
  *ngIf="!itemSelection"
  [title]="pageTitle" [actionsTemplate]="actions">
  <ng-template #actions>
    <button nz-button [nzType]="'primary'"
            class="mr-4"
            [nzSize]="'large'"
            *ngIf="resourceType == 'exercise'"
            (click)="saveListState()"
            [routerLink]="'/admin/v3/resource/exercise/batch-import'">
      <i nz-icon [nzType]="'upload'" nzTheme="outline"></i>批量导入{{titleName}}
    </button>
    <button nz-button [nzType]="'primary'"
            class="mr-4"
            [nzSize]="'large'"
            (click)="saveListState()"
            [queryParams]="getAddPageQueryParams()"
            *ngIf="resourceType == 'audio' || resourceType == 'video'"
            [routerLink]="'/admin/v3/resource/'+resourceType+'/batch-add'">
      <i nz-icon [nzType]="'plus'" nzTheme="outline"></i>批量新增{{titleName}}
    </button>
    <button nz-button [nzType]="'primary'"
            [nzSize]="'large'"
            (click)="saveListState()"
            [queryParams]="getAddPageQueryParams()"
            [routerLink]="'/admin/v3/resource/'+resourceType+'/add'">
      <i nz-icon [nzType]="'plus'" nzTheme="outline"></i>新增{{titleName}}
    </button>
  </ng-template>
</common-top-tool-bar>

<div class="page-main">
  <ng-container *ngIf="!itemSelection">
    <div class="resource-view-switch">
      <div class="ant-tabs ant-tabs-top ant-tabs-line">
        <div class="ant-tabs-nav">
          <div class="ant-tabs-nav-wrap">
            <div class="ant-tabs-nav-list">
              <div
                class="ant-tabs-tab"
                [class.ant-tabs-tab-active]="activeView === 'list'"
                (click)="onViewTabChange(0)"
              >
                <div class="ant-tabs-tab-btn pl-4">列表视图</div>
              </div>
              <div
                class="ant-tabs-tab"
                [class.ant-tabs-tab-active]="activeView === 'drive'"
                (click)="onViewTabChange(1)"
              >
                <div class="ant-tabs-tab-btn">网盘视图</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="activeView === 'list'" class="resource-view-panel">
        <nz-spin [nzSpinning]="isLoadingAttr">
          <tw-table-filter
            actionStyle="align-items: center;display: flex;"
            wrapperStyle="height: auto; padding-bottom: 1em;"
            (doFilter)="doFilter($event)">
            <div class="ml-2 inline">
              <common-search-input
                [(value)]="filter.name"
                [placeholder]="'搜索名称'"
                (clear)="clearSearch()"></common-search-input>
            </div>

            <nz-cascader class="m-2" nzChangeOnSelect
                         [(ngModel)]="levelSelectValues"
                         [nzValueProperty]="'id'"
                         [nzLabelProperty]="'name'"
                         [nzOptions]="levelSelectOptions"
                         [nzShowSearch]="true"
                         (nzClear)="onLevelClear($event)"
                         (ngModelChange)="onLevelChanges($event)"></nz-cascader>

            <ng-container *ngIf="resourceType !== 'audio' && resourceType !== 'video'">
              <nz-select nzAllowClear class="m-2"
                          *ngFor="let theme of rootSyllabusThemes;"
                          [(ngModel)]="filter.themes[theme.id]"
                          [nzDropdownMatchSelectWidth]="false"
                          [nzPlaceHolder]="themeKeyValueItems[theme.id].name">
                <nz-option [nzValue]="item['id']" [nzLabel]="item['name']"
                           *ngFor="let item of theme.children"></nz-option>
              </nz-select>

              <nz-select nzAllowClear class="m-2"
                          *ngFor="let theme of subSyllabusThemes;"
                          [(ngModel)]="filter.themes[theme.id]"
                          [nzDropdownMatchSelectWidth]="false"
                          [nzPlaceHolder]="themeKeyValueItems[theme.id].name">
                <nz-option [nzValue]="item['id']" [nzLabel]="item['name']"
                           *ngFor="let item of theme.children"></nz-option>
              </nz-select>
            </ng-container>

            <nz-select nzAllowClear
                       [(ngModel)]="filter.reserve3"
                       [nzDropdownMatchSelectWidth]="false"
                       nzPlaceHolder="教材状态">
              <nz-option [nzValue]="null" [nzLabel]="''"></nz-option>
              <nz-option [nzValue]="1" [nzLabel]="'启用'"></nz-option>
              <nz-option [nzValue]="0" [nzLabel]="'禁用'"></nz-option>
            </nz-select>
          </tw-table-filter>
        </nz-spin>
        <tw-table class="data-table" #dataTable
                  [nzTotal]='totalNum'
                  [nzPageIndex]="filter.pageIndex"
                  [nzPageSize]="filter.pageSize || 10"
                  (nzQueryParams)="onQueryParamsChange($event)"
                  [nzData]="dataSet"
                  [nzLoading]="isLoading"
        >
          <thead>
          <tr>
            <th [nzWidth]="'150'">id</th>
            <th [nzWidth]="'100'">排序</th>
            <th *ngIf="resourceType != 'exercise'">封面</th>
            <th>名称</th>
            <th [ngStyle]="{width: resourceType != 'exercise' ? '320px' : '220px'}">項目</th>
            <th style="width: 100px;">新增日期</th>
            <th style="width: 80px;">状态</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of dataTable.data">
            <td style="width: 150px;">{{row.id}}</td>
            <td
                (click)="openEditSeqModal(row)"
                style="cursor: pointer; color: #1890ff; text-decoration: underline;">
              {{getReversedSeq(row.seq)}}
            </td>
            <td *ngIf="resourceType != 'exercise'">
              <div class="h-16 w-24 m-1 rounded cover" [ngStyle]="{
              'background-image': 'url(' +  (row.cover && (row.cover.startsWith('http') ? row.cover : protocol+'//'+host+'/' + (bucket ? bucket + '/' : '') +row.cover))  + ')'
              }">
              </div>
            </td>
            <td>{{row.name}}</td>
            <td>
              <ng-container *ngIf="row.items_status">
                <nz-tag [nzColor]="'#EBFAEB'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.reading">Reading</nz-tag>
                <nz-tag [nzColor]="'#FEF7EA'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.recording">Recording</nz-tag>
                <nz-tag [nzColor]="'#DAE36F'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.listening">Listening</nz-tag>
                <nz-tag [nzColor]="'#FFE9E9'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.watching">Watching</nz-tag>
                <nz-tag [nzColor]="'#FEFEEA'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.vocabulary">Vocabulary</nz-tag>
                <nz-tag [nzColor]="'#EAFCFE'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.sentence">Sentence</nz-tag>
                <nz-tag [nzColor]="'#DCD1FF'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.dubbing">Dubbing</nz-tag>
                <nz-tag [nzColor]="'#D8EAFF'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.testing">Testing</nz-tag>
                <nz-tag [nzColor]="'#FCD9FF'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.game">Game</nz-tag>
                <nz-tag [nzColor]="'#D9F8FF'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.co_reading">動畫伴讀</nz-tag>
              </ng-container>
            </td>
            <td>{{row.created_date}}</td>
            <td>
              <nz-switch
                [disabled]="row.enabled == -1"
                (ngModelChange)="changeStatus($event, row)"
                [ngModel]="row.enabled == 1"></nz-switch>
            </td>
            <td style="width: 18rem;height: 3rem">
              <div class="operations">
                <button nz-button nzType="primary"
                  [nzSize]="'small'"
                  class="mr-4"
                  [routerLink]="'/admin/v3/resource/'+resourceType+'/edit/'+ row.id + (resourceType == 'book' || resourceType == 'cartoon' ? '/reading' : '')"
                  (click)="saveListState()"
                  [queryParams]="{tabIndex: '0'}">查看詳細</button>
                <button nz-button nzType="primary" [nzSize]="'small'" class="mr-4" [routerLink]="'/admin/v3/resource/'+resourceType+'/edit/'+ row.id" (click)="saveListState()" [queryParams]="{tabIndex: '0'}">編輯</button>
                <button nz-button nzType="primary" [nzSize]="'small'" class="mr-4" nz-popconfirm nzPopconfirmTitle="确认要复制资源？" (nzOnConfirm)="copyResource(row.id, resourceType)" *ngIf="resourceType === 'book' || resourceType === 'cartoon'">复制</button>
                <button nz-button nzType="danger" nzDanger [nzSize]="'small'" class="mr-4" nz-popconfirm nzPopconfirmTitle="资源删除后不可恢复，确定删除资源？" (nzOnConfirm)="deleteResource(row.id, resourceType)">删除</button>
              </div>
            </td>
          </tr>
          </tbody>
        </tw-table>
      </div>

      <div *ngIf="activeView === 'drive'" class="resource-view-panel">
        <tw-table-filter
          actionStyle="align-items: center;display: flex;"
          wrapperStyle="height: auto; padding-bottom: 1em;"
          (doFilter)="onDriveFilter()">
          <div class="ml-2 inline">
            <common-search-input
              [(value)]="filter.name"
              [placeholder]="'搜索名称'"
              (clear)="clearDriveSearch()"></common-search-input>
          </div>
          <nz-select nzAllowClear class="m-2"
                     [(ngModel)]="filter.reserve3"
                     [nzDropdownMatchSelectWidth]="false"
                     nzPlaceHolder="教材状态">
            <nz-option [nzValue]="null" [nzLabel]="''"></nz-option>
            <nz-option [nzValue]="1" [nzLabel]="'启用'"></nz-option>
            <nz-option [nzValue]="0" [nzLabel]="'禁用'"></nz-option>
          </nz-select>
          <button nz-button class="m-2" *ngIf="showDriveThemesFilter" (click)="openDriveThemesDrawer()">
            标签筛选
            <nz-badge *ngIf="hasActiveDriveThemes" nzStatus="processing"></nz-badge>
          </button>
          <button
            nz-button
            nzType="primary"
            class="m-2"
            *ngIf="canCreateDriveFolder"
            (click)="openDriveCreateFolderModal()">
            <i nz-icon nzType="folder-add" nzTheme="outline"></i>新建文件夹
          </button>
        </tw-table-filter>
        <app-resource-drive-view
          [treeNodes]="driveTreeNodes"
          [expandedKeys]="driveSidebarExpandedKeys"
          [selectedKeys]="driveSelectedKeys"
          [sidebarError]="driveSidebarError"
          [sidebarLoading]="isLoadingAttr"
          [contentState]="driveContentState"
          [searchKeyword]="filter.name"
          [isDriveSearch]="isDriveSearch"
          [folderCards]="driveFolderCards"
          [fileCards]="driveFileCards"
          [sortableFileCards]="driveSortableFileCards"
          [otherFileCards]="driveOtherFileCards"
          [canSortFiles]="canSortDriveFiles"
          [breadcrumb]="driveBreadcrumb"
          [filesLoadError]="driveFilesLoadError"
          [totalNum]="driveTotal"
          [pageIndex]="filter.pageIndex"
          [pageSize]="filter.pageSize"
          [resourceType]="resourceType"
          [showCopyAction]="resourceType === 'book' || resourceType === 'cartoon'"
          [currentFolderId]="currentDriveFolderId"
          [selectionResetToken]="driveSelectionResetToken"
          [hasClipboard]="hasDriveClipboard"
          [canPaste]="canDrivePaste"
          (expandedKeysChange)="onDriveSidebarExpandedKeysChange($event)"
          (folderSelect)="onDriveFolderSelect($event)"
          (folderOpen)="onDriveFolderOpen($event)"
          (breadcrumbNavigate)="onDriveBreadcrumbNavigate($event)"
          (retryCategory)="onRetryCategory()"
          (pageChange)="onDrivePageChange($event)"
          (fileOpen)="onDriveFileOpen($event)"
          (fileAction)="onDriveFileAction($event)"
          (folderAction)="onDriveFolderAction($event)"
          (folderSort)="onDriveFolderSort($event)"
          (fileSort)="onDriveFileSort($event)"
          (retryFiles)="onRetryFiles()"
          (selectionToolbarAction)="onDriveSelectionToolbarAction($event)"
        ></app-resource-drive-view>

        <nz-drawer
          nzTitle="标签筛选"
          [nzVisible]="driveThemesDrawerVisible"
          [nzWidth]="360"
          (nzOnClose)="driveThemesDrawerVisible = false">
          <ng-container *nzDrawerContent>
            <p *ngIf="!driveNav.pathIds.length" class="text-gray-500">请先进入分类目录后再筛选标签</p>
            <ng-container *ngIf="driveNav.pathIds.length">
              <nz-select nzAllowClear class="mb-3 block w-full"
                         *ngFor="let theme of driveRootThemes"
                         [(ngModel)]="driveThemes[theme.id]"
                         [nzDropdownMatchSelectWidth]="false"
                         [nzPlaceHolder]="themeKeyValueItems[theme.id]?.name">
                <nz-option [nzValue]="item['id']" [nzLabel]="item['name']"
                           *ngFor="let item of theme.children"></nz-option>
              </nz-select>
              <nz-select nzAllowClear class="mb-3 block w-full"
                         *ngFor="let theme of driveSubThemes"
                         [(ngModel)]="driveThemes[theme.id]"
                         [nzDropdownMatchSelectWidth]="false"
                         [nzPlaceHolder]="themeKeyValueItems[theme.id]?.name">
                <nz-option [nzValue]="item['id']" [nzLabel]="item['name']"
                           *ngFor="let item of theme.children"></nz-option>
              </nz-select>
              <div class="flex justify-end gap-2 mt-4">
                <button nz-button (click)="clearDriveThemes()">清空</button>
                <button nz-button nzType="primary" (click)="applyDriveThemes()">应用</button>
              </div>
            </ng-container>
          </ng-container>
        </nz-drawer>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="itemSelection">
  <nz-spin [nzSpinning]="isLoadingAttr">
  <tw-table-filter
    actionStyle="align-items: center;display: flex;"
    wrapperStyle="height: auto; padding-bottom: 1em;"
    (doFilter)="doFilter($event)">
    <div class="ml-2 inline">
      <common-search-input
        [(value)]="filter.name"
        [placeholder]="'搜索名称'"
        (clear)="clearSearch()"></common-search-input>
    </div>

    <nz-cascader class="m-2" nzChangeOnSelect
                 [(ngModel)]="levelSelectValues"
                 [nzValueProperty]="'id'"
                 [nzLabelProperty]="'name'"
                 [nzOptions]="levelSelectOptions"
                 [nzShowSearch]="true"
                 (nzClear)="onLevelClear($event)"
                 (ngModelChange)="onLevelChanges($event)"></nz-cascader>

    <ng-container *ngIf="resourceType !== 'audio' && resourceType !== 'video'">
      <nz-select nzAllowClear class="m-2"
                  *ngFor="let theme of rootSyllabusThemes;"
                  [(ngModel)]="filter.themes[theme.id]"
                  [nzDropdownMatchSelectWidth]="false"
                  [nzPlaceHolder]="themeKeyValueItems[theme.id].name">
        <nz-option [nzValue]="item['id']" [nzLabel]="item['name']"
                   *ngFor="let item of theme.children"></nz-option>
      </nz-select>

      <nz-select nzAllowClear class="m-2"
                  *ngFor="let theme of subSyllabusThemes;"
                  [(ngModel)]="filter.themes[theme.id]"
                  [nzDropdownMatchSelectWidth]="false"
                  [nzPlaceHolder]="themeKeyValueItems[theme.id].name">
        <nz-option [nzValue]="item['id']" [nzLabel]="item['name']"
                   *ngFor="let item of theme.children"></nz-option>
      </nz-select>
    </ng-container>

    <nz-select nzAllowClear
               [(ngModel)]="filter.reserve3"
               [nzDropdownMatchSelectWidth]="false"
               nzPlaceHolder="教材状态">
      <nz-option [nzValue]="null" [nzLabel]="''"></nz-option>
      <nz-option [nzValue]="1" [nzLabel]="'启用'"></nz-option>
      <nz-option [nzValue]="0" [nzLabel]="'禁用'"></nz-option>
    </nz-select>
  </tw-table-filter>
  </nz-spin>
  <tw-table class="data-table" #dataTable
            [nzTotal]='totalNum'
            [nzPageIndex]="filter.pageIndex"
            [nzPageSize]="filter.pageSize || 10"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzData]="dataSet"
            [nzLoading]="isLoading"
  >
    <thead>
    <tr>
      <th [nzWidth]="'100'" *ngIf="itemSelection && !single">选择</th>
      <th [nzWidth]="'150'">id</th>
      <th [nzWidth]="'100'">排序</th>
      <th *ngIf="resourceType != 'exercise'">封面</th>
      <th>名称</th>
      <th [ngStyle]="{width: resourceType != 'exercise' ? '320px' : '220px'}">項目</th>
      <th style="width: 100px;">新增日期</th>
      <th style="width: 80px;" *ngIf="!itemSelection">状态</th>
      <th *ngIf="!itemSelection"></th>
      <th *ngIf="itemSelection && single">选择</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of dataTable.data">
      <td *ngIf="itemSelection && !single" [nzChecked]="itemSelection.has(row.id)" (nzCheckedChange)="onItemChecked(row, $event)"></td>
      <td style="width: 150px;">{{row.id}}</td>
      <td
          (click)="openEditSeqModal(row)"
          style="cursor: pointer; color: #1890ff; text-decoration: underline;">
        {{getReversedSeq(row.seq)}}
      </td>
      <td *ngIf="resourceType != 'exercise'">
        <div class="h-16 w-24 m-1 rounded cover" [ngStyle]="{
        'background-image': 'url(' +  (row.cover && (row.cover.startsWith('http') ? row.cover : protocol+'//'+host+'/' + (bucket ? bucket + '/' : '') +row.cover))  + ')'
        }">
        </div>
      </td>
      <td>{{row.name}}</td>
      <td>
        <ng-container *ngIf="row.items_status">
          <nz-tag [nzColor]="'#EBFAEB'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.reading">Reading</nz-tag>
          <nz-tag [nzColor]="'#FEF7EA'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.recording">Recording</nz-tag>
          <nz-tag [nzColor]="'#DAE36F'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.listening">Listening</nz-tag>
          <nz-tag [nzColor]="'#FFE9E9'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.watching">Watching</nz-tag>
          <nz-tag [nzColor]="'#FEFEEA'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.vocabulary">Vocabulary</nz-tag>
          <nz-tag [nzColor]="'#EAFCFE'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.sentence">Sentence</nz-tag>
          <nz-tag [nzColor]="'#DCD1FF'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.dubbing">Dubbing</nz-tag>
          <nz-tag [nzColor]="'#D8EAFF'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.testing">Testing</nz-tag>
          <nz-tag [nzColor]="'#FCD9FF'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.game">Game</nz-tag>
          <nz-tag [nzColor]="'#D9F8FF'" class="mr-1 mb-1 text-slate-700 rounded w-24" *ngIf="row.items_status.co_reading">動畫伴讀</nz-tag>
        </ng-container>
      </td>
      <td>{{row.created_date}}</td>
      <td *ngIf="!itemSelection">
        <nz-switch
          [disabled]="row.enabled == -1"
          (ngModelChange)="changeStatus($event, row)"
          [ngModel]="row.enabled == 1"></nz-switch>
      </td>
      <td style="width: 18rem;height: 3rem" *ngIf="!itemSelection">
        <div class="operations">
          <button nz-button nzType="primary"
            [nzSize]="'small'"
            class="mr-4"
            [routerLink]="'/admin/v3/resource/'+resourceType+'/edit/'+ row.id + (resourceType == 'book' || resourceType == 'cartoon' ? '/reading' : '')"
            (click)="saveListState()"
            [queryParams]="{tabIndex: '0'}">查看詳細</button>
          <button nz-button nzType="primary" [nzSize]="'small'" class="mr-4" [routerLink]="'/admin/v3/resource/'+resourceType+'/edit/'+ row.id" (click)="saveListState()" [queryParams]="{tabIndex: '0'}">編輯</button>
          <button nz-button nzType="primary" [nzSize]="'small'" class="mr-4" nz-popconfirm nzPopconfirmTitle="确认要复制资源？" (nzOnConfirm)="copyResource(row.id, resourceType)" *ngIf="resourceType === 'book' || resourceType === 'cartoon'">复制</button>
          <button nz-button nzType="danger" nzDanger [nzSize]="'small'" class="mr-4" nz-popconfirm nzPopconfirmTitle="资源删除后不可恢复，确定删除资源？" (nzOnConfirm)="deleteResource(row.id, resourceType)">删除</button>
        </div>
      </td>
      <td *ngIf="itemSelection && single">
        <button nz-button
                nzType="primary"
                [nzLoading]="isLoading"
                (click)="selectThisItem(row)">
          选择
        </button>
      </td>
    </tr>
    </tbody>
  </tw-table>
  </ng-container>
</div>


<!-- 编辑排序号弹框 -->
<nz-modal
  [(nzVisible)]="isEditSeqModalVisible"
  nzTitle="修改排序号"
  (nzOnCancel)="cancelEditSeq()"
  [nzFooter]="null">

  <div *nzModalContent>
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">当前排序号：</label>
      <span class="text-lg font-semibold">{{originalSeqValue}}</span>
    </div>

    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">新排序号：</label>
      <nz-input-number
        [(ngModel)]="editSeqValue"
        [nzMin]="0"
        [nzMax]="10000"
        [nzStep]="1"
        [nzPlaceHolder]="'请输入新的排序号'"
        style="width: 100%;">
      </nz-input-number>
      <div class="text-xs text-gray-500 mt-1">
        排序号范围：0-10000，数值越大排序越靠前
      </div>
    </div>

    <div class="flex justify-end space-x-2">
      <button nz-button (click)="cancelEditSeq()">取消</button>
      <button nz-button
              nzType="primary"
              [nzLoading]="isLoading"
              (click)="confirmEditSeq()">
        确认修改
      </button>
    </div>
  </div>
</nz-modal>

<!-- 网盘编辑/重命名弹框 -->
<nz-modal
  [(nzVisible)]="isDriveRenameModalVisible"
  [nzTitle]="driveRenameTarget?.type === 'folder' ? '编辑文件夹' : '重命名文件'"
  (nzOnCancel)="cancelDriveRename()"
  [nzFooter]="null">

  <div *nzModalContent>
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ driveRenameTarget?.type === 'folder' ? '文件夹名称' : '新名称' }}
      </label>
      <input
        nz-input
        [(ngModel)]="driveRenameValue"
        [disabled]="driveRenameLoading"
        placeholder="请输入名称"
        (ngModelChange)="driveRenameNameDuplicated = false"
      />
      <div *ngIf="driveRenameNameDuplicated" class="text-xs text-red-500 mt-1">
        名称不可重复
      </div>
    </div>

    <div class="mb-4" *ngIf="driveRenameTarget?.type === 'folder'">
      <label class="block text-sm font-medium text-gray-700 mb-2">文件夹封面</label>
      <div class="text-center">
        <app-upload-image-with-preview-v2
          [picPreview]="true"
          style="width: 200px;display: inline-block;"
          [displayTextTemplate]="driveFolderCoverDisplayText"
          [displayIcon]="null"
          [picUrl]="driveFolderEditCover"
          (imageUploaded)="onDriveFolderCoverUploaded($event)"
          previewClass="bg-cover"
          [displayRatioWidth]="1"
          [displayRatioHeight]="1">
          <ng-template #driveFolderCoverDisplayText>
            <div class="p-6">请将封面图片拖拽至此或点击上传</div>
          </ng-template>
        </app-upload-image-with-preview-v2>
      </div>
    </div>

    <div class="flex justify-end space-x-2">
      <button nz-button (click)="cancelDriveRename()" [disabled]="driveRenameLoading">取消</button>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="driveRenameLoading"
        (click)="confirmDriveRename()">
        {{ driveRenameTarget?.type === 'folder' ? '保存' : '确认' }}
      </button>
    </div>
  </div>
</nz-modal>

<!-- 网盘移动弹框 -->
<nz-modal
  [(nzVisible)]="isDriveMoveModalVisible"
  [nzTitle]="driveMoveModalTitle"
  (nzOnCancel)="cancelDriveMove()"
  [nzFooter]="null">

  <div *nzModalContent>
    <div class="mb-4 text-sm text-gray-600" *ngIf="driveMoveTarget">
      将「{{ driveMoveTargetLabel }}」移动到：
    </div>
    <div class="mb-4 max-h-80 min-h-48 overflow-auto border border-gray-200 rounded p-2 relative">
      <div *ngIf="driveMoveTreeLoading" class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80">
        <nz-spin nzSimple nzTip="加载目录中..."></nz-spin>
      </div>
      <nz-tree
        *ngIf="!driveMoveTreeLoading"
        [nzData]="driveMoveTreeNodes"
        nzBlockNode
        nzNoAnimation
        [nzExpandedKeys]="driveMoveExpandedKeys"
        (nzExpandChange)="onDriveMoveExpandChange($event)"
        (nzClick)="onDriveMoveTreeClick($event)"
      ></nz-tree>
    </div>
    <div class="mb-4 text-sm" *ngIf="driveMoveSelectedFolderName">
      目标文件夹：{{ driveMoveSelectedFolderName }}
    </div>

    <div class="flex justify-end space-x-2">
      <button nz-button (click)="cancelDriveMove()" [disabled]="driveMoveLoading">取消</button>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="driveMoveLoading"
        [disabled]="driveMoveTreeLoading"
        (click)="confirmDriveMove()">
        确认移动
      </button>
    </div>
  </div>
</nz-modal>

<!-- 网盘新建文件夹弹框 -->
<nz-modal
  [(nzVisible)]="isDriveCreateFolderModalVisible"
  nzTitle="新建文件夹"
  (nzOnCancel)="cancelDriveCreateFolder()"
  [nzFooter]="null">

  <div *nzModalContent>
    <div class="mb-4 text-sm text-gray-600" *ngIf="driveBreadcrumb.length">
      将在「{{ driveBreadcrumb[driveBreadcrumb.length - 1].name }}」下创建文件夹
    </div>
    <div class="mb-4 text-sm text-gray-600" *ngIf="!driveBreadcrumb.length">
      将在根目录下创建文件夹
    </div>
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">文件夹名称</label>
      <input
        nz-input
        [(ngModel)]="driveCreateFolderValue"
        [disabled]="driveCreateFolderLoading"
        placeholder="请输入文件夹名称"
        (ngModelChange)="driveCreateFolderNameDuplicated = false"
        (keyup.enter)="confirmDriveCreateFolder()"
      />
      <div *ngIf="driveCreateFolderNameDuplicated" class="text-xs text-red-500 mt-1">
        名称不可重复
      </div>
    </div>

    <div class="flex justify-end space-x-2">
      <button nz-button (click)="cancelDriveCreateFolder()" [disabled]="driveCreateFolderLoading">取消</button>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="driveCreateFolderLoading"
        (click)="confirmDriveCreateFolder()">
        确认
      </button>
    </div>
  </div>
</nz-modal>
